export default __webpack_public_path__ + "static/media/calendarDo.d7f24bc3.svg";